// removed by extract-text-webpack-plugin
module.exports = {"section":"_2rNo1","active":"tRxS4","subtitle":"_2BzBr","title":"fML0m"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Section/styles.css
 ** module id = 345
 ** module chunks = 0
 **/